import { UserRole } from "src/app/core";

export const EventsRoles = [UserRole.NationalMuseumEvent];
export const LearningCenter = [UserRole.LEARNINGCENTER, UserRole.CREATOR, UserRole.APPROVER];

export const ReportsRoles = [UserRole.STATISTICSDEPARTMENT, UserRole.FINANCEDEPARTMENT];

export const Admin = [
  UserRole.ADMIN,
  UserRole.SUPERADMIN,
  UserRole.COUNTER,
  UserRole.VISITORSERVICE,
  UserRole.MUSEUMFRIENDSDEPARTMENT,
  UserRole.SECURITY,
  ...EventsRoles,
  ...ReportsRoles,
  ...LearningCenter,
];

const ServicesManagement = [UserRole.ADMIN, UserRole.COUNTER, UserRole.VISITORSERVICE];

const Calendar = [
  UserRole.ADMIN,
  UserRole.COUNTER,
  UserRole.VISITORSERVICE,
  UserRole.MUSEUMFRIENDSDEPARTMENT,
  ...EventsRoles,
  ...LearningCenter,
];

const Dashboard = [
  UserRole.ADMIN,
  UserRole.VISITORSERVICE,
  UserRole.LEARNINGCENTER,
  UserRole.MUSEUMFRIENDSDEPARTMENT,
  ...EventsRoles,

  // UserRole.COUNTER,
  // ...ReportsRoles,
  // ...EventsRoles,
];

const Reports = [
  UserRole.ADMIN,
  UserRole.COUNTER,
  UserRole.MUSEUMFRIENDSDEPARTMENT,
  UserRole.LEARNINGCENTER,
  UserRole.VISITORSERVICE,
  ...ReportsRoles,
];

export const Permissions = {
  // Kiosk: [UserRole.KIOSK],
  Home: [UserRole.CUSTOMER],
  Profile: [UserRole.CUSTOMER],
  Services: [UserRole.CUSTOMER, UserRole.GUEST],
  MyTickets: [UserRole.CUSTOMER],
  MyRequests: [UserRole.CUSTOMER],
  EvaluationsInterests: [UserRole.CUSTOMER],
  Dashboard,
  Admin,
  Calendar,
  UsersManagement: [UserRole.ADMIN, UserRole.SUPERADMIN, UserRole.VISITORSERVICE],
  Events: [UserRole.ADMIN, ...EventsRoles, ...LearningCenter],
  EventTypes: [UserRole.ADMIN],
  Memberships: [UserRole.ADMIN, UserRole.MUSEUMFRIENDSDEPARTMENT],
  Audit: [UserRole.ADMIN, UserRole.VISITORSERVICE],
  BookingServices: [UserRole.ADMIN, UserRole.COUNTER, UserRole.VISITORSERVICE],
  Reservations: [UserRole.ADMIN, UserRole.COUNTER, UserRole.VISITORSERVICE],

  ServicesManagement,
  RequestsManagement: [UserRole.ADMIN, UserRole.VISITORSERVICE],
  LearningCenter: [UserRole.ADMIN, UserRole.LEARNINGCENTER],

  SpecialTickets: [UserRole.ADMIN, UserRole.COUNTER],
  Nationalities: [UserRole.ADMIN],
  DelayPayment: [UserRole.ADMIN],
  Gates: [UserRole.ADMIN],

  Packages: [...ServicesManagement],
  GuidedTours: [...ServicesManagement],
  Product: [...ServicesManagement],
  VisitorPrices: [...ServicesManagement],
  Museums: [...ServicesManagement],
  GroupOffers: [...ServicesManagement],
  Halls: [...ServicesManagement],
  AudioDevices: [...ServicesManagement],
  Coupons: [...ServicesManagement],
  DisabilityTypes: [...ServicesManagement],

  Reports,
};
